export default "__VITE_ASSET__MB_fbnGf__"